$ = jQuery.noConflict();

// GLOBAL APP CONTROLLER
const controller = {
    init() {
        $('.block-team-carousel__slides').slick({
            arrows: true,
            dots: true,
            slidesToShow: 3,
            slidesToScroll: 3,
            prevArrow: '.block-team-carousel__arrow-prev',
            nextArrow: '.block-team-carousel__arrow-next',
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                    },
                },
                {
                    breakpoint: 700,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                    },
                },
            ],
        })
    },
    loaded() {},
    resized() {
        
    },
    scrolled() {},
    keyDown(e) {},
    scrolled() {},
    keyDown(e) {},
    mouseUp(e) {},
};
export default controller;
